import type { LocaleMessages } from '../messages.js';

export const messages = {
  'form.validation.required': 'Fill in this field',
  'form.validation.email': 'Enter a valid email address',
  'form.validation.phone': 'Enter a valid phone number',
  'form.validation.pattern': 'The value does not match the required format',
  'form.validation.minLength': 'Minimum {count} characters',
  'form.validation.maxLength': 'Maximum {count} characters',
  'form.validation.consent': 'Confirm your consent',
  'form.validation.selectOption': 'Select an option',
  'form.defaultSuccess': 'Thank you! We will contact you.',
  'form.defaultError': 'Something went wrong. Please try again.',
  'form.sending': 'Sending…',
  'form.editModeDisabled': 'Form submission is disabled in edit mode',
  'form.successTitle': 'Request sent',
  'form.successButton': 'Done',
  'countdown.dayShort': 'd',
  'countdown.expired': 'Time has expired',
  'copy.success': 'Copied',
  'video.play': 'Play video',
  'video.frameTitle': 'Video',
  'slider.previous': 'Previous slide',
  'slider.next': 'Next slide',
  'lightbox.previous': 'Previous image',
  'lightbox.next': 'Next image',
  'lightbox.close': 'Close',
  'map.loading': 'Loading map…',
  'map.loadError': 'Could not load the map',
} satisfies LocaleMessages;
